import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import "./SearchBar.css"

import styled from 'styled-components'

type SearchBarProps = {
    navigate: boolean
    placeholder: string,
    value: any
    mobile?: boolean,
    onChange?: any,
    hideSearch?: boolean
    
}
export const SearchBar = (props: SearchBarProps) => {
    const { placeholder, mobile, onChange, value, hideSearch} = props

    const _onChange = (e) => {
        if(!!onChange){
            onChange(e?.target?.value)
        }
    }
    return(
        <form className={"w-form"}>
            <input 
                className="search-input" 
                style={{
                    fontSize: mobile ? "1em" : "2em",
                    paddingBottom: mobile ? 0 : 20
                }}
                onChange={_onChange}
                type="text"
                value={value}
                placeholder={placeholder || ""}
                />
                {!hideSearch && <FaSearch color={'white'} className="search-icon" size={mobile ? 15 : 35}/>}
        </form>
    )
}

type InputProps = {

    placeholder?: string,
    value: any
    mobile?: boolean,
    onChange?: any,
    type?: string
    hasError?: boolean
    
}
const _Input = styled.input`
    width: 100%;
    font-size: 1.4em;
    border-bottom: ${(props: {hasError: boolean}) => props.hasError ? `2px solid red` : '2px solid hsla(0, 0%, 47.1%, 0.9);'}
`

export const Input = (props: InputProps) => {
    const { placeholder, mobile, onChange, value, type, hasError} = props

    const _onChange = (e) => {
        if(!!onChange){
            onChange(e?.target?.value)
        }
    }
    return(
        <_Input 
                hasError={hasError}
                className="search-input" 
                onChange={_onChange}
                type={type ? type : "text"}
                value={value}
                placeholder={placeholder || ""}
                />
    )

}